import type { ExperimentalQueries } from '../__types__/ExperimentalQueries'; //eslint-disable-line no-restricted-imports
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalGetAutomationRuleById: ExperimentalQueries['experimentalGetAutomationRuleById'] =
	async (_, { cloudId, spaceId, automationStack, ruleId }, { network }) => {
		return fetchJSON(
			network,
			`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/rest/${spaceId}/rule/${ruleId}`,
			{
				method: 'GET',
				credentials: 'include',
				headers: {
					'Content-Type': MediaType.JSON,
				},
			},
		).then((response) => {
			return {
				id: response.id,
				clientKey: response.clientKey,
				name: response.name,
				state: response.state,
				description: response.description,
				authorAccountId: response.authorAccountId,
				actor: response.actor,
				created: response.created,
				updated: response.updated,
				trigger: response.trigger,
				components: response.components,
				canOtherRuleTrigger: response.canOtherRuleTrigger,
				notifyOnError: response.notifyOnError,
				projects: response.projects,
				labels: response.labels,
				tags: response.tags,
				ruleScope: response.ruleScope,
				ruleHome: response.ruleHome,
				writeAccessType: response.writeAccessType,
				collaborators: response.collaborators,
				billingType: response.billingType,
			};
		});
	};
